import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {phonePortraitOutline, phonePortraitSharp} from "ionicons/icons"

interface props {
    active?: boolean
}

const ListItemButtonAlertPhone: React.FC<props> = ({ active = true }) => {

    const { t } = useTranslation()
        , [presentAlert] = useIonAlert()

    const alertMessage = async (e: any, active: boolean) => {
        e.preventDefault()
        e.stopPropagation()

        const translationKey: string = active ? 'phone' : 'no_phone';

        return presentAlert({
            header:  t('people.alerts.' + translationKey + '.header'),
            message: t('people.alerts.' + translationKey + '.message', { itemType: t('people.title_item').toLowerCase() }),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    return (
        <IonButton color={active ? 'medium' : 'light'} fill="clear" title={t('people.alerts.phone.header').toString()}
                   onClick={(e) => alertMessage(e, active)}>
            <IonIcon slot="icon-only" ios={phonePortraitOutline} md={phonePortraitSharp} />
        </IonButton>
    )
}

export default ListItemButtonAlertPhone